// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__31U88","textLoading":"loader_textLoading__3WY3l"};